import { render, staticRenderFns } from "./PerformanceTableBox.vue?vue&type=template&id=62a49c90&"
import script from "./PerformanceTableBox.vue?vue&type=script&lang=js&"
export * from "./PerformanceTableBox.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceTableBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports